import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames/bind';
import { RadioGroup, Text } from '@beef/ui-kit';
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
export var ColorPickerSection = function ColorPickerSection(_ref) {
  var _device$color3;
  var size = _ref.size,
    device = _ref.device,
    onChangeColor = _ref.onChangeColor;
  var onColorClick = useCallback(function (e) {
    if (onChangeColor) {
      onChangeColor(e.target.value);
    }
  }, [onChangeColor]);
  var mappedColors = useMemo(function () {
    var _device$color;
    var colors = (_device$color = device.color) !== null && _device$color !== void 0 ? _device$color : [];
    return colors.map(function (item) {
      return {
        itemValue: item.value,
        color: item.label
      };
    });
  }, [device]);
  var currentRadio = useMemo(function () {
    var _device$color2;
    var colors = (_device$color2 = device.color) !== null && _device$color2 !== void 0 ? _device$color2 : [];
    return colors.find(function (item) {
      return item.isActive;
    });
  }, [device]);
  return device !== null && device !== void 0 && (_device$color3 = device.color) !== null && _device$color3 !== void 0 && _device$color3.length ? /*#__PURE__*/React.createElement("div", {
    className: cx('section', size && "section--".concat(size))
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size5-r-s"
  }, "\u0426\u0432\u0435\u0442"), /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper')
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    items: mappedColors,
    name: "colors",
    onChange: onColorClick,
    radioVariant: "color",
    size: "big",
    value: currentRadio === null || currentRadio === void 0 ? void 0 : currentRadio.value
  }))) : null;
};